module.exports = __webpack_public_path__ + "static/media/lydia.2f1ac174.jpg";